var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.300725 1.08197C0.593618 0.789081 1.06849 0.789081 1.36138 1.08197L4.75427 4.47486L8.14716 1.08197C8.44005 0.789081 8.91493 0.789081 9.20782 1.08197C9.50071 1.37487 9.50071 1.84974 9.20782 2.14263L5.81493 5.53552L9.20782 8.92841C9.50071 9.2213 9.50071 9.69618 9.20782 9.98907C8.91493 10.282 8.44005 10.282 8.14716 9.98907L4.75427 6.59618L1.36138 9.98907C1.06849 10.282 0.593618 10.282 0.300725 9.98907C0.00783136 9.69618 0.00783136 9.2213 0.300725 8.92841L3.69361 5.53552L0.300725 2.14263C0.00783136 1.84974 0.00783136 1.37487 0.300725 1.08197Z",
    fill: "#3A4669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBtn);
export default __webpack_public_path__ + "static/media/cancelBtn.0f6faaebaf6320be2c08b5ae841527d1.svg";
export { ForwardRef as ReactComponent };